// removed by extract-text-webpack-plugin
module.exports = {"form":"login-confirmation-form__form__1mTkU","error":"login-confirmation-form__error__3-sPk","error-transparent":"login-confirmation-form__error-transparent__wxaV9","code-input":"login-confirmation-form__code-input__3KRYq","action-link":"login-confirmation-form__action-link__2ikPy","button-wrapper":"login-confirmation-form__button-wrapper__24RUO","button":"login-confirmation-form__button__t2PXh","name-fields":"login-confirmation-form__name-fields__3XGCU","icon-wrapper":"login-confirmation-form__icon-wrapper__1QJwl","left-chevron-icon":"login-confirmation-form__left-chevron-icon__2DsGQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/login-confirmation-form.scss
// module id = 1242
// module chunks = 1